import {
	FormControl,
	OutlinedInput,
	Typography,
	FormHelperText,
} from "@mui/material";
import React from "react";

const OutlinedInputField = (props) => {
	let { label, onChange, value, classname, prop,...others } = props;

	return (
		<FormControl variant="outlined" fullWidth>
			<Typography
				component={FormHelperText}
				sx={{ fontWeight: "bold" }}
				variant="subtitle2"
			>
				{label}
			</Typography>
			<OutlinedInput
				inputProps={{
					style: {
						padding: 5,
						textTransform: "uppercase",
					},
                    ...prop
				}}
				{...others}
				size="small"
				className={classname}
				onChange={onChange}
				value={value}
			/>
		</FormControl>
	);
};

export default OutlinedInputField;
